import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from './store/store';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {init as initDescriptors} from './api/index';
import './styles/reset.css';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: 'ru', // if you're using a language detector, do not define the lng option
    debug: true,
    });

initDescriptors();
const root = ReactDOM.createRoot(document.getElementById('root'));

// store.dispatch({ type: 'TREE_INIT', data: mainMenu });

root.render(
  <Provider store={store}>
  <App />
</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
